import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchedProfessionFragment = (
  { __typename?: 'Profession' }
  & Pick<Types.Profession, 'id' | 'objectId' | 'name'>
  & { relatedQualifs: (
    { __typename?: 'QualificationConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'QualificationEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Qualification' }
        & Pick<Types.Qualification, 'id' | 'objectId' | 'name'>
      )> }
    )>>> }
  ) }
);

export type GetProfessionFromLabelQueryVariables = Types.Exact<{
  professionLabel: Types.Scalars['String']['input'];
}>;


export type GetProfessionFromLabelQuery = (
  { __typename?: 'Query' }
  & { professions: (
    { __typename?: 'ProfessionConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ProfessionEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Profession' }
        & Pick<Types.Profession, 'id' | 'objectId' | 'name'>
        & { relatedQualifs: (
          { __typename?: 'QualificationConnection' }
          & { edges?: Types.Maybe<Array<Types.Maybe<(
            { __typename?: 'QualificationEdge' }
            & { node?: Types.Maybe<(
              { __typename?: 'Qualification' }
              & Pick<Types.Qualification, 'id' | 'objectId' | 'name'>
            )> }
          )>>> }
        ) }
      )> }
    )>>> }
  ) }
);

export const FetchedProfessionFragmentDoc = gql`
    fragment FetchedProfession on Profession {
  id
  objectId
  name
  relatedQualifs {
    edges {
      node {
        id
        objectId
        name
      }
    }
  }
}
    `;
export const GetProfessionFromLabelDocument = gql`
    query getProfessionFromLabel($professionLabel: String!) {
  professions(where: {name: {equalTo: $professionLabel}}, first: 1) {
    edges {
      node {
        ...FetchedProfession
      }
    }
  }
}
    ${FetchedProfessionFragmentDoc}`;

/**
 * __useGetProfessionFromLabelQuery__
 *
 * To run a query within a React component, call `useGetProfessionFromLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfessionFromLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfessionFromLabelQuery({
 *   variables: {
 *      professionLabel: // value for 'professionLabel'
 *   },
 * });
 */
export function useGetProfessionFromLabelQuery(baseOptions: Apollo.QueryHookOptions<GetProfessionFromLabelQuery, GetProfessionFromLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfessionFromLabelQuery, GetProfessionFromLabelQueryVariables>(GetProfessionFromLabelDocument, options);
      }
export function useGetProfessionFromLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfessionFromLabelQuery, GetProfessionFromLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfessionFromLabelQuery, GetProfessionFromLabelQueryVariables>(GetProfessionFromLabelDocument, options);
        }
export type GetProfessionFromLabelQueryHookResult = ReturnType<typeof useGetProfessionFromLabelQuery>;
export type GetProfessionFromLabelLazyQueryHookResult = ReturnType<typeof useGetProfessionFromLabelLazyQuery>;
export type GetProfessionFromLabelQueryResult = Apollo.QueryResult<GetProfessionFromLabelQuery, GetProfessionFromLabelQueryVariables>;